module.exports = __webpack_public_path__ + "media/homepage/HERO-01-6adaeaf0.webp";